import React, { useEffect, useState } from "react";
import './App.css';
import '../src/style/common.css';
import Bowser from "bowser";
import axios from 'axios';
import AppRoutes from './routes';
import { connect } from 'react-redux';
import { I18nextProvider } from 'react-i18next';
import i18n from 'i18next';
import { config as i18nextConfig } from './translations';
i18n.init(i18nextConfig);

  function App() {

  let systemInfo = {
    ip: "",
    deviceId: ""
  }
  const  browser = Bowser.getParser(navigator.userAgent);
  useEffect(()=>{
    if (browser) {
      systemInfo.deviceId = browser.getPlatform().type + " - " + browser.getBrowser().name + " " + browser.getBrowser().version + " - " + browser.getOS().name + " " + browser.getOS().version || '';
    }
    axios.get('https://api.ipify.org')
    .then((response) => {
      systemInfo.ip = response.data;
      sessionStorage.setItem('systemInfo', JSON.stringify(systemInfo));
    }).catch((error) => {
      systemInfo.ip = ''
      sessionStorage.setItem('systemInfo', JSON.stringify(systemInfo));
    });
  })
    return (
      <I18nextProvider i18n={i18n}>
        <AppRoutes/>
      </I18nextProvider>
    )
  
}

const mapDispatchToProps = (dispatch) => ({
});

const mapStateToProps = (state) => ({
});

export default connect(mapStateToProps, mapDispatchToProps)(App);
